export const polygonArrayToGeometry = (arr) => {
  // let str = `POLYGON ((`
  // arr[0].map((d,i)=>{
  //     return i != arr[0].length-1 ? str = str+' '+d[0]+' '+d[1]+',' : str = str+' '+d[0]+' '+d[1]+'))'
  // })

  let str = "POLYGON ((";

  // İlk koordinat setini kapatın
  str += arr[0].map((d) => `${d[0]} ${d[1]}`).join(",");

  // Daha fazla iç halka (hole) varsa ekleyin
  for (let i = 1; i < arr.length; i++) {
    str += `), (${arr[i].map((d) => `${d[0]} ${d[1]}`).join(",")}`;
  }

  // Kapalı son parantezleri ekleyin
  str += "))";

  return str;
};

export const numberConvert = (text) => {
  let formattedStr = "0";
  if (text !== undefined && text !== null && text !== "") {
    let num = parseFloat(text).toFixed(0).toString();
    let ar = num.split(",");
    let integerPart = ar[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    formattedStr = integerPart;
  }

  return formattedStr;
};
